/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S5_Cloudflare_DescInputs */

const tr_cerez_s5_cloudflare_desc = /** @type {(inputs: Cerez_S5_Cloudflare_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bot koruması, performans (zorunlu)`)
};

const en_cerez_s5_cloudflare_desc = /** @type {(inputs: Cerez_S5_Cloudflare_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bot protection, performance (necessary)`)
};

const de_cerez_s5_cloudflare_desc = /** @type {(inputs: Cerez_S5_Cloudflare_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bot-Schutz, Leistung (erforderlich)`)
};

const ru_cerez_s5_cloudflare_desc = /** @type {(inputs: Cerez_S5_Cloudflare_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`защита от ботов, производительность (обязательно)`)
};

/**
* | output |
* | --- |
* | "bot protection, performance (necessary)" |
*
* @param {Cerez_S5_Cloudflare_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s5_cloudflare_desc = /** @type {((inputs?: Cerez_S5_Cloudflare_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S5_Cloudflare_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s5_cloudflare_desc(inputs)
	if (locale === "de") return de_cerez_s5_cloudflare_desc(inputs)
	if (locale === "ru") return ru_cerez_s5_cloudflare_desc(inputs)
	return tr_cerez_s5_cloudflare_desc(inputs)
});